import react from "react"
import React, { Component } from 'react';
// import { useEffect } from "react";
// import { useLocation } from "react-router";
export const ScrollTop = () => {
    return (
        <div></div>
    )
}
